function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import singleSpaEvents from './constants/singleSpaEvents';
var System = window.System;
var _logger = /*#__PURE__*/new WeakMap();
var _performance = /*#__PURE__*/new WeakMap();
var _performanceStart = /*#__PURE__*/new WeakMap();
var _afterRoutingEvent = /*#__PURE__*/new WeakMap();
var _appsWaitingForSlot = /*#__PURE__*/new WeakMap();
var _readySlots = /*#__PURE__*/new WeakMap();
var _pageLoadingIsDone = /*#__PURE__*/new WeakMap();
var _markSlotAsReady = /*#__PURE__*/new WeakMap();
var AsyncBootUp = /*#__PURE__*/function () {
  function AsyncBootUp() {
    var _this = this;
    var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.console;
    var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance;
    _classCallCheck(this, AsyncBootUp);
    _classPrivateFieldInitSpec(this, _logger, void 0);
    _classPrivateFieldInitSpec(this, _performance, void 0);
    _classPrivateFieldInitSpec(this, _performanceStart, void 0);
    _classPrivateFieldInitSpec(this, _afterRoutingEvent, false);
    _classPrivateFieldInitSpec(this, _appsWaitingForSlot, {});
    _classPrivateFieldInitSpec(this, _readySlots, []);
    _classPrivateFieldInitSpec(this, _pageLoadingIsDone, false);
    _classPrivateFieldInitSpec(this, _markSlotAsReady, function (id) {
      setTimeout(function () {
        // All slots has been loaded
        if (id === Infinity) {
          // Infinity here used as indicator of the end of the slots list
          _classPrivateFieldSet(_pageLoadingIsDone, _this, true);
          for (var slotName in _classPrivateFieldGet(_appsWaitingForSlot, _this)) {
            _classPrivateFieldGet(_appsWaitingForSlot, _this)[slotName]();
          }
        } else {
          _classPrivateFieldGet(_readySlots, _this).push(id);
          if (_classPrivateFieldGet(_appsWaitingForSlot, _this)[id]) {
            _classPrivateFieldGet(_appsWaitingForSlot, _this)[id]();
            delete _classPrivateFieldGet(_appsWaitingForSlot, _this)[id];
          }
        }
      }, 0);
    });
    _classPrivateFieldSet(_logger, this, logger);
    _classPrivateFieldSet(_performance, this, performance);
    _classPrivateFieldSet(_performanceStart, this, _classPrivateFieldGet(_performance, this).now());
    for (var _i2 = 0, _window$ilcApps2 = window.ilcApps; _i2 < _window$ilcApps2.length; _i2++) {
      var id = _window$ilcApps2[_i2];
      _classPrivateFieldGet(_markSlotAsReady, this).call(this, id);
    }
    window.ilcApps = {
      push: function push(id) {
        return _classPrivateFieldGet(_markSlotAsReady, _this).call(_this, id);
      }
    };
    window.addEventListener(singleSpaEvents.ROUTING_EVENT, function () {
      return _classPrivateFieldSet(_afterRoutingEvent, _this, true);
    });
  }
  return _createClass(AsyncBootUp, [{
    key: "waitForSlot",
    value: function waitForSlot(slotName) {
      try {
        var _this2 = this;
        var res = {
          spaBundle: null,
          cssBundle: null,
          wrapperPropsOverride: null
        };
        if (_classPrivateFieldGet(_afterRoutingEvent, _this2)) {
          return _await(res);
        }
        return _await(new Promise(function (resolve) {
          if (_classPrivateFieldGet(_readySlots, _this2).includes(slotName)) {
            return resolve();
          } else if (!_classPrivateFieldGet(_pageLoadingIsDone, _this2)) {
            _classPrivateFieldGet(_appsWaitingForSlot, _this2)[slotName] = resolve;
          } else {
            return resolve(); // We don't have such slot on the page
          }
        }), function () {
          if (!_classPrivateFieldGet(_afterRoutingEvent, _this2)) {
            var milliseconds = _classPrivateFieldGet(_performance, _this2).now() - _classPrivateFieldGet(_performanceStart, _this2);
            _classPrivateFieldGet(_logger, _this2).info("ILC: Registering app @".concat(slotName, " after ").concat(milliseconds, " milliseconds."));
          }
          var slotEl = document.getElementById(slotName);
          if (slotEl === null) {
            _classPrivateFieldGet(_logger, _this2).warn("Looks like we're missing slot \"".concat(slotName, "\" in template... Ignoring possible config overrides..."));
            return res;
          }
          var overridesEl = slotEl.querySelector('script[type="text/spa-config-override"]');
          if (overridesEl) {
            var conf = JSON.parse(overridesEl.innerHTML);
            if (conf.spaBundle) {
              System.overrideImportMap(conf.appName, conf.spaBundle);
              res.spaBundle = conf.spaBundle;
            }
            if (conf.cssBundle) {
              res.cssBundle = conf.cssBundle;
            }
            if (conf.wrapperPropsOverride) {
              res.wrapperPropsOverride = conf.wrapperPropsOverride;
            }
            if (conf.dependencies) {
              for (var id in conf.dependencies) {
                if (conf.dependencies.hasOwnProperty(id)) {
                  System.overrideImportMap(id, conf.dependencies[id]);
                }
              }
            }
            overridesEl.parentNode.removeChild(overridesEl);
          }
          return res;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);
}();
export { AsyncBootUp as default };